/**
 * Pipeline Error Classes
 * 
 * Errors related to pipeline execution.
 */

/**
 * Error thrown during pipeline execution.
 */
export class PipelineError extends Error {
  constructor(
    /** Human-readable message */
    message: string,
    /** The step that caused the error */
    public readonly stepId?: string,
    /** The underlying cause */
    public readonly cause?: Error
  ) {
    super(message);
    this.name = 'PipelineError';
  }

  /**
   * Create a "tool not found" error.
   */
  static toolNotFound(toolId: string, stepId: string): PipelineError {
    return new PipelineError(
      `Tool "${toolId}" not found in registry`,
      stepId
    );
  }

  /**
   * Create a "step failed" error.
   */
  static stepFailed(stepId: string, cause: Error): PipelineError {
    return new PipelineError(
      `Step "${stepId}" failed: ${cause.message}`,
      stepId,
      cause
    );
  }

  /**
   * Create an "empty pipeline" error.
   */
  static emptyPipeline(): PipelineError {
    return new PipelineError('Pipeline has no enabled steps');
  }
}

